import React from 'react';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import NewButton from '../../common/components/NewButton';
import ui from '../../common/services/ui';
import { Panel } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';

const List = ({ t, parentId, ...rest }) => {
	const columns = [
		{
			header: t('ParentDocument_Name'),
			accessor: 'name',
			sortable: true,
			cell: (name, row) => (row.document ? <a target='blank' href={row.document.url}>{name}</a> : <span>{name}</span>)
		},
		{
			header: t('Common_Created'),
			accessor: 'created',
			sortable: true,
			cell: created => ui.formatDateTime(created)
		},
		{
			header: t('Common_Modified'),
			accessor: 'modified',
			sortable: true,
			cell: modified => ui.formatDateTime(modified)
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id) => <Link to={`/parents/${parentId}/parentDocuments/${id}`} className='btn btn-teal'><FontAwesomeIcon icon={faEdit} /> {t('Common_Edit')}</Link>
		}
	];

	return <Panel>
		<Panel.Body>
			<PagedEntitiesList columns={columns} listActions={<NewButton newItemPath={`/parents/${parentId}/parentDocuments/new`} />} {...rest} />
		</Panel.Body>
	</Panel>;
};

export default withTranslation()(List);